$(function(){
  if($(".tooltip-warning").length > 0){
    $(".tooltip-warning").tooltip();
  }
});